module.exports = __webpack_public_path__ + "img/phone.ab63eba4.svg";